/* PureEthical v60 - protecao contra bots nos formularios (subscricao, aviso de stock, contacto).
   1. Armadilha invisivel: um campo escondido (fora do ecra, sem tab, aria-hidden). Pessoas nao o veem nem o preenchem;
      robots que preenchem tudo preenchem-no - o envio e cancelado em silencio.
   2. Tempo minimo: um formulario enviado menos de 2,5 s depois de aparecer e de um robot - cancelado em silencio.
   3. Email com aspeto descartavel/aleatorio conhecido (dominios de teste) - cancelado.
   Nao trava pedidos feitos diretamente ao servidor sem browser: para esses, a Shopify tem o hCaptcha
   (Loja online > Preferencias > Protecao contra spam). Nunca bloqueia o checkout. */
(function () {
  'use strict';
  var HP = 'pe_hp_url', T0 = Date.now(), MIN = 2500;
  var BAD = /@(ilovemyemail\.net|mailinator\.|guerrillamail\.|sharklasers\.|yopmail\.|10minutemail\.|tempmail\.|temp-mail\.|trashmail\.|dispostable\.|maildrop\.cc)/i;
  function isLead(f) {
    if (!f || f.tagName !== 'FORM') return false;
    var a = (f.getAttribute('action') || '').toLowerCase();
    var ft = f.querySelector('input[name="form_type"]');
    var t = ft ? String(ft.value).toLowerCase() : '';
    return t === 'customer' || t === 'contact' || /\/contact(\b|#|$|\?)/.test(a);
  }
  function arm(f) {
    if (!isLead(f) || f.__peG) return;
    f.__peG = 1;
    /* forms que ja vinham na pagina contam desde o inicio do carregamento (a pessoa pode ter escrito antes deste script correr);
       os que aparecem depois (pop-up) contam desde que aparecem */
    var t0 = (document.readyState !== 'complete' && window.performance && performance.timeOrigin) ? Math.round(performance.timeOrigin) : Date.now();
    f.setAttribute('data-pe-t', String(t0));
    if (!f.querySelector('input[name="' + HP + '"]')) {
      var w = document.createElement('div');
      w.setAttribute('aria-hidden', 'true');
      w.style.cssText = 'position:absolute!important;left:-10000px!important;top:auto!important;width:1px!important;height:1px!important;overflow:hidden!important';
      var i = document.createElement('input');
      i.type = 'text'; i.name = HP; i.tabIndex = -1; i.autocomplete = 'off'; i.value = '';
      w.appendChild(i); f.appendChild(w);
    }
  }
  function scan(root) { var fs = (root || document).querySelectorAll ? (root || document).querySelectorAll('form') : []; for (var k = 0; k < fs.length; k++) arm(fs[k]); }
  function block(e, f) {
    e.preventDefault(); e.stopImmediatePropagation();
    try { f.setAttribute('data-pe-blocked', '1'); } catch (x) {}
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!isLead(f)) return;
    arm(f);
    var hp = f.querySelector('input[name="' + HP + '"]');
    if (hp && hp.value) return block(e, f);
    var t = parseInt(f.getAttribute('data-pe-t') || T0, 10) || T0;
    if (Date.now() - t < MIN && !f.__peRetry) { f.__peRetry = 1; return block(e, f); } /* um 2.o clique passa sempre - uma pessoa nunca fica presa */
    var em = f.querySelector('input[type="email"], input[name="contact[email]"]');
    if (em && BAD.test(String(em.value || ''))) return block(e, f);
  }, true);
  function start() {
    scan(document);
    if (window.MutationObserver) {
      new MutationObserver(function (ms) {
        for (var a = 0; a < ms.length; a++) for (var b = 0; b < ms[a].addedNodes.length; b++) {
          var n = ms[a].addedNodes[b];
          if (n.nodeType !== 1 || n.tagName === 'FONT') continue;
          if (n.tagName === 'FORM') arm(n); else if (n.querySelector && n.querySelector('form')) scan(n);
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
